import { ResponsiveBlockSwitcher } from "@/shared/Components";
import type { FC } from "react";
import type { PersonInfoCardProps } from "./types";
import { PersonInfoCardDesktop } from "./desktop";
import { PersonInfoCardMobile } from "./mobile";

export const PersonInfoCard: FC<PersonInfoCardProps> = ({
  content,
  isEdit,
  showMobileMenu,
  avatarIsEditable,
  showEdit,
  form,
}) => {
  return (
    <ResponsiveBlockSwitcher
      desktop={
        <PersonInfoCardDesktop
          content={content}
          isEdit={isEdit}
          avatarIsEditable={avatarIsEditable}
        />
      }
      mobile={
        <PersonInfoCardMobile
          showMobileMenu={showMobileMenu}
          content={content}
          isEdit={isEdit}
          showEdit={showEdit}
          form={form}
        />
      }
    />
  );
};
